import BaseSportScoring from './BaseSportScoring';

class FootballScoring extends BaseSportScoring {
  constructor() {
    super('football');
  }

  get label() { return 'Football'; }

  /**
   * Only Goalkeepers can record saves.
   */
  canRecordMetric(metricKey, player) {
    if (metricKey === 'save' && player?.position !== 'Goalkeeper') {
      return { allowed: false, reason: 'Only a Goalkeeper can record a save.' };
    }
    return { allowed: true };
  }
}

export default FootballScoring;
